import React from "react";
import { SportingEvent } from "../data/api";
import { VStack, Skeleton, Heading, Box, Flex, Text } from "@chakra-ui/react";
import moment from "moment";
import SportIcon from "./SportIcon";

export const TimetableDaySkeleton = () => {
  return (
    <VStack w="full" alignItems="start">
      <Skeleton h={30} w="70%" />
      {[...new Array(5)].map((i) => (
        <Skeleton h={7} w="full" key={i} />
      ))}
    </VStack>
  );
};

type Props = {
  date: string;
  events: SportingEvent[];
};

export const TimetableDay = ({ date, events }: Props) => {
  return (
    <VStack w="full" alignItems="start">
      <Heading size="md" mb={2}>
        {moment(date).format("dddd Do MMMM")}
      </Heading>

      {events.map((event, i) => (
        <Flex alignItems="center" gap={4} w="full" key={i}>
          <SportIcon sport={event.team.sport} />
          <Box flex={1} textAlign="left">
            <Text>
              <strong>{event.team.sport.title}</strong> - {event.team.title}
            </Text>
            <Text fontSize="sm" opacity={0.5}>
              {event.location.name}
            </Text>
          </Box>
          <Box opacity={0.8}>{moment(event.start).format("HH:mm")}</Box>
        </Flex>
      ))}
    </VStack>
  );
};
